(function () {
  'use strict';

  if (window.S10Attribution) return;

  var ATTRIBUTION_KEYS = [
    'gclid',
    'wbraid',
    'gbraid',
    'gclid_backup',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'campaign_id',
    'campaign_label',
    'asset_group_id',
    'ad_group_id',
    'creative_id',
    'target_id',
    'device',
    'network',
    'tw_source',
    'tw_campaign',
    'tw_adid',
    'tw_kwdid'
  ];
  var TOUCH_META_KEYS = ['captured_at', 'landing_page'];
  var LEGACY_COOKIE_PREFIX = 's10_';
  var LAST_TOUCH_COOKIE_PREFIX = 's10_lt_';
  var FIRST_TOUCH_COOKIE_PREFIX = 's10_ft_';
  var COOKIE_MAX_AGE = 60 * 60 * 24 * 90;
  var landingParams = normaliseAttribution(readUrlParams());
  var readyResolve;
  var ready = new Promise(function (resolve) {
    readyResolve = resolve;
  });
  var readySettled = false;
  var lastConsentState = null;
  var lastPublishedAttribution = '';
  var lastCartSyncFingerprint = '';

  function readUrlParams() {
    var params = new URLSearchParams(window.location.search);
    return ATTRIBUTION_KEYS.reduce(function (result, key) {
      var value = (params.get(key) || '').trim();
      if (value) result[key] = value.slice(0, 255);
      return result;
    }, {});
  }

  function normaliseAttribution(attribution) {
    var result = Object.assign({}, attribution || {});

    if (!result.gclid && result.gclid_backup) result.gclid = result.gclid_backup;
    if (!result.campaign_id) {
      result.campaign_id = result.utm_campaign || result.tw_campaign || '';
    }
    if (!result.utm_campaign && result.campaign_id) {
      result.utm_campaign = result.campaign_id;
    }

    if ((result.gclid || result.wbraid || result.gbraid) && !result.utm_source) {
      result.utm_source = 'google';
    }
    if ((result.gclid || result.wbraid || result.gbraid) && !result.utm_medium) {
      result.utm_medium = 'cpc';
    }

    return Object.keys(result).reduce(function (clean, key) {
      if (result[key]) clean[key] = String(result[key]).slice(0, 255);
      return clean;
    }, {});
  }

  function hasTrackedTouch(attribution) {
    return Boolean(
      attribution.gclid ||
        attribution.wbraid ||
        attribution.gbraid ||
        attribution.campaign_id ||
        attribution.utm_campaign ||
        attribution.tw_campaign
    );
  }

  function readCookie(prefix, key) {
    var name = prefix + key + '=';
    var cookies = document.cookie ? document.cookie.split('; ') : [];

    for (var i = 0; i < cookies.length; i += 1) {
      if (cookies[i].indexOf(name) === 0) {
        try {
          return decodeURIComponent(cookies[i].slice(name.length));
        } catch (error) {
          return cookies[i].slice(name.length);
        }
      }
    }

    return '';
  }

  function writeCookie(prefix, key, value) {
    document.cookie =
      prefix +
      key +
      '=' +
      encodeURIComponent(value) +
      ';max-age=' +
      COOKIE_MAX_AGE +
      ';path=/;SameSite=Lax;Secure';
  }

  function clearTouch(prefix) {
    ATTRIBUTION_KEYS.concat(TOUCH_META_KEYS).forEach(function (key) {
      document.cookie =
        prefix + key + '=;max-age=0;path=/;SameSite=Lax;Secure';
    });
  }

  function marketingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!privacy) return null;

    try {
      if (typeof privacy.marketingAllowed === 'function') {
        return Boolean(privacy.marketingAllowed());
      }
      if (typeof privacy.firstPartyMarketingAllowed === 'function') {
        return Boolean(privacy.firstPartyMarketingAllowed());
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  function getTouch(prefix) {
    return ATTRIBUTION_KEYS.concat(TOUCH_META_KEYS).reduce(function (result, key) {
      var value = readCookie(prefix, key);
      if (value) result[key] = value;
      return result;
    }, {});
  }

  function getLegacyAttribution() {
    return normaliseAttribution(getTouch(LEGACY_COOKIE_PREFIX));
  }

  function getAttribution() {
    var lastTouch = normaliseAttribution(getTouch(LAST_TOUCH_COOKIE_PREFIX));
    return Object.keys(lastTouch).length ? lastTouch : getLegacyAttribution();
  }

  function getFirstTouch() {
    var firstTouch = normaliseAttribution(getTouch(FIRST_TOUCH_COOKIE_PREFIX));
    return Object.keys(firstTouch).length ? firstTouch : getAttribution();
  }

  function writeTouch(prefix, attribution, includeMeta) {
    Object.keys(attribution).forEach(function (key) {
      if (ATTRIBUTION_KEYS.indexOf(key) !== -1) {
        writeCookie(prefix, key, attribution[key]);
      }
    });

    if (includeMeta) {
      writeCookie(prefix, 'captured_at', new Date().toISOString());
      writeCookie(
        prefix,
        'landing_page',
        (window.location.pathname + window.location.search).slice(0, 255)
      );
    }
  }

  function persistLandingParams() {
    var lastTouch = getTouch(LAST_TOUCH_COOKIE_PREFIX);
    var firstTouch = getTouch(FIRST_TOUCH_COOKIE_PREFIX);
    var legacy = getLegacyAttribution();

    if (hasTrackedTouch(landingParams)) {
      // A new tracked landing replaces the complete last-touch record so a
      // missing field cannot inherit a value from the previous campaign.
      clearTouch(LAST_TOUCH_COOKIE_PREFIX);
      clearTouch(LEGACY_COOKIE_PREFIX);
      writeTouch(LAST_TOUCH_COOKIE_PREFIX, landingParams, true);
      writeTouch(LEGACY_COOKIE_PREFIX, landingParams, false);

      if (!hasTrackedTouch(firstTouch)) {
        writeTouch(FIRST_TOUCH_COOKIE_PREFIX, landingParams, true);
      }
      return;
    }

    // Migrate the original s10_* cookie format without changing attribution.
    if (!hasTrackedTouch(lastTouch) && hasTrackedTouch(legacy)) {
      writeTouch(LAST_TOUCH_COOKIE_PREFIX, legacy, false);
    }
    if (!hasTrackedTouch(firstTouch) && hasTrackedTouch(legacy)) {
      writeTouch(FIRST_TOUCH_COOKIE_PREFIX, legacy, false);
    }
  }

  function appendHiddenField(form, label, value) {
    if (!value) return;

    var name = 'contact[' + label + ']';
    var field = form.querySelector('input[name="' + name + '"]');

    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }

    field.value = value;
  }

  function populateForms() {
    var attribution = getAttribution();
    var firstTouch = getFirstTouch();
    var fieldMap = {
      gclid: 'Google click ID',
      wbraid: 'Google WBRAID',
      gbraid: 'Google GBRAID',
      campaign_id: 'Google campaign ID',
      campaign_label: 'Google campaign label',
      asset_group_id: 'Google asset group ID',
      ad_group_id: 'Google ad group ID',
      creative_id: 'Google creative ID',
      target_id: 'Google target ID',
      device: 'Google device',
      network: 'Google network',
      utm_source: 'UTM source',
      utm_medium: 'UTM medium',
      utm_campaign: 'UTM campaign',
      utm_content: 'UTM content',
      utm_term: 'UTM term',
      tw_campaign: 'Triple Whale campaign ID'
    };

    document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
      Object.keys(fieldMap).forEach(function (key) {
        appendHiddenField(form, fieldMap[key], attribution[key]);
      });
      appendHiddenField(form, 'First-touch campaign ID', firstTouch.campaign_id);
      appendHiddenField(form, 'First-touch campaign label', firstTouch.campaign_label);
      appendHiddenField(form, 'First-touch source', firstTouch.utm_source);
      appendHiddenField(form, 'First-touch medium', firstTouch.utm_medium);
      appendHiddenField(form, 'Attribution landing page', attribution.landing_page);
      appendHiddenField(form, 'Attribution captured at', attribution.captured_at);
    });
  }

  function syncCartAttributes() {
    var attribution = getAttribution();
    var firstTouch = getFirstTouch();
    var attributes = {
      'Attribution campaign ID': attribution.campaign_id || '',
      'Attribution campaign label': attribution.campaign_label || '',
      'Attribution first campaign ID': firstTouch.campaign_id || '',
      'Attribution first campaign label': firstTouch.campaign_label || '',
      'Attribution asset group ID': attribution.asset_group_id || '',
      'Attribution ad group ID': attribution.ad_group_id || '',
      'Attribution Google click ID':
        attribution.gclid || attribution.wbraid || attribution.gbraid || '',
      'Attribution source': attribution.utm_source || '',
      'Attribution medium': attribution.utm_medium || '',
      'Attribution landing page': attribution.landing_page || '',
      'Attribution captured at': attribution.captured_at || '',
      'Attribution TW campaign ID': attribution.tw_campaign || ''
    };

    attributes = Object.keys(attributes).reduce(function (result, key) {
      if (attributes[key]) result[key] = attributes[key];
      return result;
    }, {});

    if (!Object.keys(attributes).length) return Promise.resolve();

    var fingerprint = JSON.stringify(attributes);

    if (lastCartSyncFingerprint === fingerprint) return Promise.resolve();

    try {
      if (window.sessionStorage.getItem('s10_cart_attribution') === fingerprint) {
        lastCartSyncFingerprint = fingerprint;
        return Promise.resolve();
      }
    } catch (error) {
      // Continue without session-level request deduplication.
    }

    lastCartSyncFingerprint = fingerprint;

    return window
      .fetch(
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/') + 'cart/update.js',
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }
      )
      .then(function (response) {
        if (!response.ok) throw new Error('Cart attribution update failed');
        try {
          window.sessionStorage.setItem('s10_cart_attribution', fingerprint);
        } catch (error) {
          // The cart update succeeded; storage is only an optimization.
        }
      })
      .catch(function () {
        if (lastCartSyncFingerprint === fingerprint) lastCartSyncFingerprint = '';
        // Attribution must never interrupt browsing or checkout.
      });
  }

  function stampKlaviyoProfile(event) {
    if (!event.detail || event.detail.type !== 'submit') return;
    if (!window.klaviyo || typeof window.klaviyo.identify !== 'function') return;

    var attribution = getAttribution();
    var firstTouch = getFirstTouch();
    var metadata = event.detail.metaData || {};
    var identifier = {};

    if (metadata.email) identifier.email = metadata.email;
    if (metadata.phone_number) identifier.phone_number = metadata.phone_number;
    if (!identifier.email && !identifier.phone_number) return;
    if (!hasTrackedTouch(attribution)) return;

    var profileProperties = Object.assign(identifier, {
      'S10 Last Campaign ID': attribution.campaign_id || '',
      'S10 Last Campaign Label': attribution.campaign_label || '',
      'S10 First Campaign ID': firstTouch.campaign_id || '',
      'S10 First Campaign Label': firstTouch.campaign_label || '',
      'S10 Asset Group ID': attribution.asset_group_id || '',
      'S10 Google Click ID':
        attribution.gclid || attribution.wbraid || attribution.gbraid || '',
      'S10 Attribution Source': attribution.utm_source || '',
      'S10 Attribution Medium': attribution.utm_medium || '',
      'S10 Attribution Landing Page': attribution.landing_page || '',
      'S10 Attribution Captured At': attribution.captured_at || '',
      'S10 Last Klaviyo Form ID': event.detail.formId || ''
    });
    var eventProperties = {
      form_id: event.detail.formId || '',
      campaign_id: attribution.campaign_id || '',
      campaign_label: attribution.campaign_label || '',
      first_campaign_id: firstTouch.campaign_id || '',
      first_campaign_label: firstTouch.campaign_label || '',
      asset_group_id: attribution.asset_group_id || '',
      click_id: attribution.gclid || attribution.wbraid || attribution.gbraid || '',
      attribution_source: attribution.utm_source || '',
      attribution_medium: attribution.utm_medium || '',
      landing_page: attribution.landing_page || ''
    };

    try {
      var identifyRequest = window.klaviyo.identify(profileProperties);

      if (
        identifyRequest &&
        typeof identifyRequest.then === 'function' &&
        typeof window.klaviyo.track === 'function'
      ) {
        identifyRequest
          .then(function () {
            window.klaviyo.track('S10 Attributed Form Submission', eventProperties);
          })
          .catch(function () {
            // Klaviyo retries and observability are handled by its onsite library.
          });
      } else if (typeof window.klaviyo.track === 'function') {
        window.klaviyo.track('S10 Attributed Form Submission', eventProperties);
      }
    } catch (error) {
      // The form has already submitted; attribution enrichment must not affect it.
    }
  }

  function pushDataLayerOnce(eventName, parameters, deduplicationKey) {
    var key = 's10_event_' + (deduplicationKey || eventName);

    try {
      if (window.sessionStorage.getItem(key)) return false;
      window.sessionStorage.setItem(key, '1');
    } catch (error) {
      // Continue when storage is unavailable; Google Ads still counts these
      // lead actions once per ad click.
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      Object.assign(
        {
          event: eventName,
          event_source: 's10home_theme'
        },
        parameters || {}
      )
    );
    return true;
  }

  function findMatches(scope, selector) {
    var elements = [];

    if (scope.nodeType === 1 && scope.matches && scope.matches(selector)) {
      elements.push(scope);
    }

    if (scope.querySelectorAll) {
      Array.prototype.push.apply(elements, scope.querySelectorAll(selector));
    }

    return elements;
  }

  function publishFormConversion(eventName, formType, formLocation) {
    pushDataLayerOnce(
      eventName,
      {
        form_type: formType,
        form_location: formLocation
      },
      eventName + ':' + formType + ':' + window.location.pathname
    );
  }

  function publishConfirmedFormConversions(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var elements = findMatches(scope, '[data-s10-conversion-success]');

    elements.forEach(function (element) {
      var eventName = element.getAttribute('data-s10-conversion-success');
      if (!eventName) return;

      var formType = element.getAttribute('data-s10-form-type') || 'contact';
      var formLocation =
        element.getAttribute('data-s10-form-location') || window.location.pathname;

      publishFormConversion(eventName, formType, formLocation);
    });

    // Backward compatibility for the live Minimog forms. These elements are
    // rendered only when Shopify confirms a successful contact-form POST.
    // Scoping the generic notification to the contact-page section prevents
    // newsletter and customer-account success messages from counting as leads.
    findMatches(
      scope,
      '[data-section-type="contact-page"] form[action*="/contact"] .notification.show.success'
    ).forEach(function () {
      publishFormConversion('contact_form_submit', 'contact', 'contact_page');
    });

    findMatches(
      scope,
      '.m-form-ask-question form[action*="/contact"] .form-ask__success'
    ).forEach(function () {
      publishFormConversion(
        'question_form_submit',
        'product_question',
        'product_page'
      );
    });
  }

  function observeConfirmedFormConversions() {
    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) publishConfirmedFormConversions(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  // Klaviyo application forms: SitBuC = Trade Programme, Unqw3N = Ambassador
  // Programme. Newsletter and event forms (TqAxLz, XM5Nen, Ve6AgY, SMmhXr)
  // must never count as applications. No PII enters the data layer here —
  // full submissions reach Supabase via the Klaviyo flow webhook (ERP track).
  var KLAVIYO_APPLICATION_FORMS = {
    SitBuC: { event: 'trade_form_submit', formType: 'trade_application' },
    Unqw3N: { event: 'ambassador_form_submit', formType: 'ambassador_application' }
  };

  function publishKlaviyoApplicationConversions(event) {
    if (!event.detail || event.detail.type !== 'submit') return;
    var mapping = KLAVIYO_APPLICATION_FORMS[event.detail.formId];
    if (!mapping) return;

    pushDataLayerOnce(
      mapping.event,
      {
        form_type: mapping.formType,
        form_location: window.location.pathname
      },
      mapping.event + ':' + event.detail.formId
    );
  }

  function normaliseCalendlyLinks() {
    document
      .querySelectorAll(
        'a[href^="https://calendly.com/s10home/s10home-showroom-invite"]'
      )
      .forEach(function (link) {
        link.href = '/pages/showroom#book-showroom';
        link.removeAttribute('target');
        link.removeAttribute('rel');
      });
  }

  function applyAttribution() {
    var allowed = marketingAllowed();
    lastConsentState = allowed;

    if (allowed === true) {
      persistLandingParams();
      populateForms();
      syncCartAttributes();
      var attribution = getAttribution();
      var fingerprint = JSON.stringify(attribution);

      if (fingerprint !== lastPublishedAttribution) {
        lastPublishedAttribution = fingerprint;
        document.dispatchEvent(
          new CustomEvent('s10:attribution-updated', { detail: attribution })
        );
      }
    }

    if (!readySettled && allowed !== null) {
      readySettled = true;
      readyResolve(allowed);
    }
  }

  function waitForPrivacyApi() {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      applyAttribution();

      if (lastConsentState !== null || attempts >= 40) {
        window.clearInterval(timer);
        if (!readySettled) {
          readySettled = true;
          readyResolve(false);
        }
      }
    }, 100);
  }

  window.S10Attribution = {
    get: getAttribution,
    getFirstTouch: getFirstTouch,
    ready: ready,
    refresh: applyAttribution,
    populateForms: populateForms,
    syncCart: syncCartAttributes,
    pushDataLayerOnce: pushDataLayerOnce
  };

  function initialiseAttribution() {
    normaliseCalendlyLinks();
    publishConfirmedFormConversions();
    observeConfirmedFormConversions();
    applyAttribution();
    waitForPrivacyApi();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAttribution, {
      once: true
    });
  } else {
    initialiseAttribution();
  }

  document.addEventListener('visitorConsentCollected', applyAttribution);
  window.addEventListener('PandectesEvent_OnConsent', applyAttribution);
  window.addEventListener('klaviyoForms', stampKlaviyoProfile);
  window.addEventListener('klaviyoForms', publishKlaviyoApplicationConversions);
  document.addEventListener('s10:form-rendered', populateForms);
  window.addEventListener('pageshow', function () {
    publishConfirmedFormConversions();
  });
  document.addEventListener('shopify:section:load', function (event) {
    normaliseCalendlyLinks();
    publishConfirmedFormConversions(event.target);
  });
})();
